'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smallInputs = undefined;
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _input = require('./input');
var _input2 = _interopRequireDefault(_input);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var smallInputs = exports.smallInputs = function smallInputs(props) {
  return {
    width: props.width || '6rem',
    textAlign: 'center',
    display: 'inline-block',
    marginRight: props.theme.space_xs
  };
};
exports.default = (0, _glamorous2.default)(_input2.default)(smallInputs);